import { Fade, MenuList, Popover } from '@mui/material'
import { FloatingMenuPopoverHeader } from './FloatingMenuPopoverHeader'
import { FloatingMenuPopoverFooter } from './FloatingMenuPopoverFooter'
import { floatingMenuPaperSx } from './floatingMenuPaperSx'
import { useLastPopoverAnchor } from './useLastPopoverAnchor'
import styles from './index.module.scss'

/**
 * @param {import('@mui/material').PopoverProps & {
 *   header?: import('react').ReactNode, paperClassName?: string, paperSx?: import('@mui/material').SxProps,
 *   listRef: import('react').RefObject<HTMLElement | null>, menuListId?: string, menuListAriaLabel: string,
 *   listClassName?: string, entries: import('react').ReactNode,
 * }} props
 */
export function FloatingMenuPopover({ open, anchorEl, onClose, hideBackdrop, anchorOrigin, transformOrigin, header, footer, paperClassName, paperSx, listRef, menuListId, menuListAriaLabel, listClassName, entries }) {
  const resolvedAnchor = useLastPopoverAnchor(anchorEl)
  const fadeOut = transformOrigin?.vertical === 'bottom'
  return (
    <Popover
      open={open}
      anchorEl={resolvedAnchor}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      {...(fadeOut ? { TransitionComponent: Fade } : {})}
      marginThreshold={8}
      slotProps={{
        backdrop: hideBackdrop
          ? {
              invisible: true,
              sx: {
                backgroundColor: 'transparent',
                backdropFilter: 'none',
              },
            }
          : undefined,
        paper: {
          elevation: 0,
          className: [styles.paper, paperClassName].filter(Boolean).join(' '),
          sx: floatingMenuPaperSx(Boolean(header) || Boolean(footer), paperSx),
        },
      }}
    >
      <FloatingMenuPopoverHeader header={header} />
      <MenuList ref={listRef} id={menuListId} dense disablePadding aria-label={menuListAriaLabel} className={[styles.list, listClassName].filter(Boolean).join(' ')} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', alignSelf: 'stretch', width: '100%', minWidth: 0, padding: 0 }}>
        {entries}
      </MenuList>
      <FloatingMenuPopoverFooter footer={footer} />
    </Popover>
  )
}
